module.exports = __webpack_public_path__ + "static/img/PHOTO-HAYWARD-A4.530e6f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/PHOTO-HAYWARD-A4.png
// module id = hwxJ
// module chunks = 4